import { btnPresets, FilledButtonVariantProps } from "../button/FilledButton"

export const navbarButtonPresetStyle: FilledButtonVariantProps = {
  ...btnPresets.small,
  boxClassName: "px-3 py-2",
}
